import { render } from "./HeroiconsSolidEyeOff.vue?vue&type=template&id=61748089"
const script = {}

import exportComponent from "/Users/hamid/Nova/onsho24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidEyeOff.vue"]])

export default __exports__